
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.854 8.457l-4.236 4.235a.872.872 0 0 1-1.236 0l-2.236-2.235a.25.25 0 0 1 0-.353l.708-.707a.249.249 0 0 1 .353 0L9 11.19l3.793-3.793a.25.25 0 0 1 .354 0l.707.707a.25.25 0 0 1 0 .353M10 1a9 9 0 1 0 .001 18.001A9 9 0 0 0 10 1"}})])
          )
        }
      }
    